import { defineComponent } from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import elementHelper from '@/helpers/documentHelper';
export default defineComponent({
    name: 'listing-pagination',
    computed: Object.assign(Object.assign(Object.assign({}, mapGetters('blue', {
        currentPageInfo: 'currentPageInfo',
    })), mapGetters('global', {
        isMobile: 'isMobile',
    })), { page: {
            get: function () {
                var _a, _b;
                return (_b = (_a = this.currentPageInfo) === null || _a === void 0 ? void 0 : _a.current_page) !== null && _b !== void 0 ? _b : 0;
            },
            set: function (new_value) {
                this.updateListing(new_value);
                elementHelper.scrollToTarget('.blueProductListingContentMain');
            },
        } }),
    methods: Object.assign(Object.assign(Object.assign({}, mapActions('blue', {
        loadListing: 'LOAD_PRODUCTS_LISTING',
    })), mapMutations('blue', {
        patchPageInfo: 'SET_CURRENT_PAGE',
    })), { updateListing(targetPage) {
            this.patchPageInfo(targetPage);
            this.loadListing();
        } }),
});
